/**
 * bootprompt.js locale configuration
 * locale : Norwegian
 * author : Nils Magnus Englund
 */

import { addLocale } from "../bootprompt";

addLocale("no", {
  OK: "OK",
  CANCEL: "Avbryt",
  CONFIRM: "OK",
});
